import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export class ItineraryCriticalInformation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
    }

    this.handleClickTracking = this.props.handleClickTracking.bind(this)
  }

  render() {
    const criticalInfoButtonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const criticalInfoBackgroundColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)

    return (
      <div className={`departure-info__essentials__critical-info ${criticalInfoBackgroundColor}`}>
        <h5>{this.props.block.heading}</h5>
        <div className="textbuttoncontainer">
          <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></span>
          {this.props.block.buttonText && this.props.block.buttonLink ? (
            <div className="cta-button">
              <a
                className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                  buttonColor ? buttonColor : "casc-blue"
                }`}
                href={this.props.block.buttonLink}
                onClick={() => this.handleClickTracking(this.props.block.buttonTracking)}
              >
                {criticalInfoButtonSvg ? <Svg iconName={"criticalInfoButtonSvg"} /> : ""}
                <span className="text">{this.props.block.buttonText}</span>
              </a>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    )
  }
}
